import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M21 3H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h9V5h8c.55 0 1 .45 1 1v8h2V5c0-1.1-.9-2-2-2zm-1 10.25c0-.41-.34-.75-.75-.75h-5.5c-.41 0-.75.34-.75.75s.34.75.75.75h5.5c.41 0 .75-.34.75-.75zM19.25 9h-5.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.5c.41 0 .75.34.75.75s-.34.75-.75.75zm-5.5 2.5h5.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5.5c-.41 0-.75.34-.75.75s.34.75.75.75zm5.73 8.66c.04-.29.13-.79.28-1.5l.63-2.87h1.49l-1.41 5.71h-1.82l-.55-2.49c-.0046-.0229-.0108-.0517-.0181-.086-.0248-.1156-.0634-.2951-.1019-.534-.05-.31-.09-.57-.12-.78-.02.17-.05.38-.1.63-.0154.0769-.0298.1519-.0439.225-.0316.1646-.0615.3196-.0961.465-.05.21-.24 1.06-.57 2.56h-1.82l-1.41-5.71h1.49l.62 2.86c.14.63.24 1.13.29 1.51.0247-.214.0765-.5024.1386-.8486L16.4 19.07c.08-.45.16-.83.24-1.13l.5-2.16h1.43l.49 2.16.0077.0335c.078.3414.1648.7211.2423 1.1665l.0209.1199c.0695.3996.1218.6997.1491.9001z"
  }],
  circles: []
};
var BooksWfIcon = function BooksWfIcon(props) {
  return renderIcon(props, iconType);
};
export { BooksWfIcon };